// Angular imports
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

// Devextream imports
import notify from 'devextreme/ui/notify';

// Constant imports
import { MessageInterval } from '../../../_constants/messages-intervals';
import { AccConstants } from '../../_constants/acc-constant';

// Service imports
import { ServerErrorService } from '../../../_services/shared-services/server-error.service';
import { SharedAccApplicationService } from '../../_services/shared-acc-application.service';

// Model imports
import { BaseProcessNotesResultDto } from '../../../management-common/_models/notes/base-process-notes-result-dto';
import { AccAddNotesParameterDto } from '../../_models/acc-add-notes-parameter-dto';

@Component({
    selector: 'app-architectual-application-notes-editor',
    templateUrl: './architectual-application-notes-editor.component.html',
    styleUrls: ['./architectual-application-notes-editor.component.scss']
})
export class ArchitectualApplicationNotesEditorComponent implements OnInit {
    @Input() visible: boolean;
    @Input() notesType: string;
    @Input() notesEditorParam: any;
    @Output() onNotesEditorClose = new EventEmitter<boolean>();

    loadingVisible = false;

    previousNotes: BaseProcessNotesResultDto = new BaseProcessNotesResultDto();
    popupTitle = '';
    isNoteSaved = false;

    projectNotes = AccConstants.PROJECT_NOTES;

    constructor(
        private readonly errorService: ServerErrorService,
        private readonly accApplicationService: SharedAccApplicationService
    ) {}

    ngOnInit() {
        if (!!this.notesEditorParam && this.notesEditorParam.accItemId) {
            this.popupTitle = this.notesEditorParam.accItemId;
            this.populateNotes();
        }
    }

    onNotesPopClose(): void {
        this.previousNotes = null;
        this.visible = false;
        this.onNotesEditorClose.emit(this.isNoteSaved);
    }

    onSaveNotes(note: string): void {
        const param: AccAddNotesParameterDto = new AccAddNotesParameterDto();
        param.accItemId = this.notesEditorParam.accItemId;
        param.communityId = this.notesEditorParam.communityId;
        param.customerId = this.notesEditorParam.customerId;
        param.note = note;
        param.clearCache = true;
        let notesService: any;
        if (this.notesType === this.projectNotes) {
            notesService = this.accApplicationService.saveAccProjectNotes(param);
        } else {
            notesService = this.accApplicationService.saveAccItemNotes(param);
        }
        this.loadingVisible = true;
        notesService.subscribe(
            () => {
                notify('Note successfully saved.', 'success', MessageInterval.successMsgInterval);
                this.isNoteSaved = true;
                this.onNotesPopClose();
                this.loadingVisible = false;
            },
            (error) => {
                this.loadingVisible = false;
                this.errorService.displayError(error);
            }
        );
    }

    private populateNotes(): void {
        let notesService: any;
        if (this.notesType === this.projectNotes) {
            notesService = this.accApplicationService.getAccProjectNotes(this.notesEditorParam);
        } else {
            notesService = this.accApplicationService.getAccItemNotes(this.notesEditorParam);
        }
        this.loadingVisible = true;
        notesService.subscribe(
            (result) => {
                this.previousNotes = result;
                this.loadingVisible = false;
            },
            (error) => {
                this.loadingVisible = false;
                this.errorService.displayError(error);
            }
        );
    }
}
